/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import HeaderScripts from "./header-scripts";

const Seo = ({ description, title, language, keywords, slug, children }) => {

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            social {
              twitter
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const lang = language?language:'en'
  

  return (
    <>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:creator"
        content={site.siteMetadata?.social?.twitter || ``}
      />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
                  <meta name="docsearch:version" content="2.0" />
                  <meta
                    name="google-site-verification"
                    content="NpKJJn1040oSpfG_jkExBu-Ci4CdC-euoGfgZYq75EA"
                  />
                  <link rel="icon" href="/images/favicon/elsevier-favicon.png" type="image/png" />
                  <link rel="icon" href="/images/favicon/elsevier-favicon.svg" type="image/svg+xml" />
                  <link rel="apple-touch-icon" href="/images/favicon/elsevier-apple-touch-icon.png" />
                  <link
                    rel="apple-touch-icon"
                    sizes="57x57"
                    href="/images/favicon/elsevier-icon-192.png"
                  />
                  <link
                    rel="apple-touch-icon"
                    sizes="512x512"
                    href="/images/favicon/elsevier-icon-512.png"
                  />
                  <link
                    rel="apple-touch-icon"
                    sizes="192X192"
                    href="/images/favicon/elsevier-icon-maskable-192.png"
                    purpose="maskable"
                  />                  
                  <HeaderScripts slug={slug} />
      {children}
    </>
  )
}

export default Seo

